export default __webpack_public_path__ + "static/media/nidhi-shettigar.15be67ae.jpeg";